import * as React from 'react';
import {styled} from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, {AccordionProps} from '@mui/material/Accordion';
import MuiAccordionSummary, {AccordionSummaryProps,} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import "./fullcoloraccordion.scss";
import Button from "../../core/button/button";

const FullColorAccordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({theme}) => ({
    border: `0px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    }, '&.Mui-expanded': {
        backgroundColor: "#2B2D42",
        color: "#fff",
    },
    marginBottom: '25px',
    boxShadow: '0px 24px 64px #EDF2F5',
    borderRadius: '12px',
    backgroundColor: "#fff",
    color: "#000",
    transition: 'all ease 0.5s',
    width: '90%',
    margin: '25px auto',
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        {...props}
        expandIcon={<ArrowForwardIosSharpIcon sx={{fontSize: '0.9rem'}}/>}
    />
))(({theme}) => ({
    flexDirection: 'row',
    '& .MuiAccordionSummary-expandIconWrapper': {
        transform: 'rotate(-90deg)',
        color: "#000",
        transition: 'all ease 0.5s'
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
        color: "#fff",
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    }, '&.Mui-expanded': {
        borderRadius: '12px 12px 0 0',
        borderBottom: '1px solid #D5D5D9',
    },
    padding: '15px 30px',
    fontWeight: '600',
    borderRadius: '12px',
    textAlign: 'right',
    transition: 'all linear 0.3s'
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
    padding: '30px',
    color: "#D5D5D9",
    borderRadius: '0 0 12px 12px',
    '& p': {
        fontWeight: '300',
        lineHeight: '2'
    },
}));

export default function FullAccordion() {
    const [expanded, setExpanded] = React.useState<string | false>('panel1');

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            console.log(event)
            setExpanded(newExpanded ? panel : false);
            console.log(expanded)
        };

    return (
        <div className="DropDown">
            <FullColorAccordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <div className="d-flex align-items-center gap-3">
                        <img src={require("../../assets/images/icons/MoreSell.svg").default} style={{width: '40px'}}
                             alt="" className="align-middle"/>
                        <Typography>فروش بیشتر</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند این متن برای توضیحات
                        مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند
                    </Typography>
                </AccordionDetails>
            </FullColorAccordion>
            <FullColorAccordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                    <div className="d-flex align-items-center gap-3">
                        <img src={require("../../assets/images/icons/SatisfyCustomer.svg").default}
                             style={{width: '40px'}} alt="" className="align-middle"/>
                        <Typography>مشتری راغب</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                        malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor
                        sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                        sit amet blandit leo lobortis eget.
                    </Typography>
                </AccordionDetails>
            </FullColorAccordion>
            <FullColorAccordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                    <div className="d-flex align-items-center gap-3">
                        <img src={require("../../assets/images/icons/WebsiteTraffic.svg").default}
                             style={{width: '40px'}} alt="" className="align-middle"/>
                        <Typography>ترافیک وبسایت</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                        malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor
                        sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                        sit amet blandit leo lobortis eget.
                    </Typography>
                </AccordionDetails>
            </FullColorAccordion>
            <FullColorAccordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
                    <div className="d-flex align-items-center gap-3">
                        <img src={require("../../assets/images/icons/BrandKnowledge.svg").default}
                             style={{width: '40px'}} alt="" className="align-middle"/>
                        <Typography>آگاه سازی نسبت به برند</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                        malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor
                        sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                        sit amet blandit leo lobortis eget.
                    </Typography>
                </AccordionDetails>
            </FullColorAccordion>
            <FullColorAccordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
                    <div className="d-flex align-items-center gap-3">
                        <img src={require("../../assets/images/icons/LocalAds.svg").default} style={{width: '40px'}}
                             alt="" className="align-middle"/>
                        <Typography>تبلیغ محلی</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                        malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor
                        sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                        sit amet blandit leo lobortis eget.
                    </Typography>
                </AccordionDetails>
            </FullColorAccordion>
            <div className="Accordion-Divider"></div>
            <div className="DropDown-Footer">
                <div className="row">
                    <div className="col-lg-8 col-12">
                        <div className="d-flex justify-content-start align-items-center gap-2">
                            <img src={require("../../assets/images/icons/DigitalMarket.svg").default} alt=""
                                 style={{width: '50px'}} className="img-fluid"/>
                            <div className="DropDown-Footer-Text pt-3">
                                <h6>من دیجیتال مارکتر هستم</h6>
                                <p>بدون نمایش هدف کانال ها و رسانه های تبلیغاتی را مشاهده و بر اساس نیاز خود انتخاب
                                    کنید.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-12 mt-2">
                        <Button type={"secondary"} action={() => {
                        }} responsive={true}>تغییر به مود حرفه ای</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}